import { FormEvent, useState } from 'react';
import { Form, FormGroup, FormLabel, FormControl, Button, Alert } from 'react-bootstrap';
import toastr from '../toastr';
import LoginPanel from './LoginPanel';
import AuthService from '../../services/AuthService';
import history from '../../history';
import { useRecaptcha } from '../form/Recaptcha';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [warning, setWarning] = useState('');
  const [loading, setLoading] = useState(false);
  const [captcha, Recaptcha] = useRecaptcha();

  const handleResetPassword = () => {
    if (!email) {
      setWarning('Please enter a valid email address.');
      return;
    }

    if (loading) {
      return;
    }

    setLoading(true);

    AuthService.resetPassword(email, captcha as string)
      .then(() => {
        history.push('/login');
        toastr.success('Password Reset', `An email has been sent to ${email} with further instructions`, {
          autoClose: false,
        });
      })
      .catch(({ message }) => {
        setWarning(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    handleResetPassword();
  };

  const renderAlerts = () => {
    if (warning) {
      return (
        <Alert variant="danger" onClose={() => setWarning('')}>
          {warning}
        </Alert>
      );
    }

    return null;
  };

  return (
    <LoginPanel>
      {renderAlerts()}
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <FormLabel>Email</FormLabel>
          <FormControl
            type="text"
            id="email"
            value={email}
            onChange={event => setEmail(event.target.value)}
            placeholder="username@domain.com"
          />
          <FormControl.Feedback />
        </FormGroup>
        {Recaptcha}
        <div className="login-controls">
          <Button variant="primary" block onClick={handleResetPassword} disabled={loading}>
            Send Reset Link
          </Button>
          <Button variant="secondary" block onClick={() => history.push('/login')}>
            Cancel
          </Button>
        </div>
      </Form>
    </LoginPanel>
  );
};

export default ForgotPassword;
